<template>
  <RatingRow
    v-if="context.request.feature_flags.ff_redesign_rating && !hideRating"
    :solidity="rating"
    :reviews-count="reviewsCount"
    :reviews-href="reviewsHref"
    centered
  />
  <a
    v-else-if="context.request.feature_flags.ff_redesign_rating && hideRating"
    data-qa="analyses_lpu_card_reviews_link"
    :href="reviewsHref"
    class="text-body-2 primary--text text-decoration-none link-decoration-none text-no-wrap"
  >
    {{ reviewsCountText }}
  </a>
  <div
    v-else
    class="d-flex align-center justify-center ga-3 flex-wrap"
  >
    <a
      v-if="!hideRating"
      :href="reviewsHref"
      data-qa="analyses_lpu_card_rating"
      class="d-inline-flex align-center gc-1 py-1 px-2 rounded bg-gray-40 text-decoration-none"
    >
      <span class="ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0" />
      <span class="text-subtitle-2 text--text">
        {{ formattedRating }}
      </span>
    </a>

    <a
      data-qa="analyses_lpu_card_reviews_link"
      :href="reviewsHref"
      class="text-body-2 primary--text text-decoration-none text-no-wrap"
    >
      {{ reviewsCountText }}
    </a>
  </div>
</template>

<script setup lang="ts">
/**
 * Рейтинг на карточке клиники в анализах / диагностике.
 *
 * При `ff_redesign_rating` — общий RatingRow (без badge при hideRating).
 * Иначе — локальная разметка badge + ссылка.
 */
import { computed } from 'vue'
import {
  formatLpuCardRating,
  formatLpuCardReviewsCountText,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/_functions/formatLpuCardTexts'
import { useContextStore } from 'src/store'
import type { CommonContextStore } from 'src/types/context'
import RatingRow from 'src/components/common/RatingRow/RatingRow.vue'

const props = defineProps<{
  rating: number
  reviewsCount: number
  reviewsHref: string
  hideRating?: boolean
}>()

const { context }: CommonContextStore = useContextStore()

const formattedRating = computed(() => formatLpuCardRating(props.rating))
const reviewsCountText = computed(() => formatLpuCardReviewsCountText(props.reviewsCount))
</script>
